export default "__VITE_ASSET__DHGXshTl__"